import { ScElement, ScItem, ShortPhraseFields } from '@/types/sitecore';
import { DynamicFormFields, DynamicFormValueField } from '@/types/form/dynamic-form';
import { Field } from '@sitecore-jss/sitecore-jss-vue';
import { FormDropdownOption } from '@/types/form/form-dropdown/form-dropdown';
import api from '@/api';
import { uniqBy } from 'lodash-es';

export interface FormAutoCompleteProps {
  item?: ScItem<FormAutoCompleteFields>;
}
export interface FormAutoCompleteFields extends DynamicFormValueField {
  label: Field<string>;
  placeholder: Field<string>;
  prevIcon: Field<string>;
  nextIcon: Field<string>;
  type?: ScItem<ShortPhraseFields>;
}
export interface FormAutoCompleteOptionsProps {
  value?: string;
  loading?: boolean;
  options: FormDropdownOption[];
}
export interface FormAutoCompleteOptionsEmits {
  (e: 'option-click', option: FormDropdownOption): void;
}
export const formAutoCompleteFns: Record<string, (options: any) => Promise<FormDropdownOption[]>> =
  {
    // institution: async (options: any) => {
    //   const [res, ex] = await api.bff.common.organizations(null, options);
    //   if (!res) return [];
    //   return uniqBy(
    //     res.data.map((item: any) => {
    //       return {
    //         text: item.companyName,
    //         value: item.companyName
    //       } as FormDropdownOption;
    //     }),
    //     (x) => x.value
    //   );
    // }
  };
